<template>
<div :class="`card-list ${selectable ? 'selectable' : ''}`" style=" position: relative; overflow: hidden">
<div style="display: flex; align-items: center;">
    <!--<img :src="require(`@/assets/previews/${card.code}.png`)" style="position: absolute; right: 0;     width: 76%;top: -50px; opacity: 0.3; transform: rotate(52deg) translate(-77px, -26px);">-->
    <img :src="`http://mylassets.mattkingz.cl/previews/${card.code}.jpg`" style="position: absolute; right: 0; bottom: -25px; width: 50px;">
    <div style="display: flex; flex-direction: column; width:100%; z-index: 1" v-if="display == 'LIST'">
        <div style="display: flex; align-items: center">
            <div class="card-icon oro" :style="{'background-image': `url(${require('@/assets/icon_oro.png')})`}"><span v-if="card.tipo != 'Oro'">{{card.coste}}</span></div>
            <div v-if="card.tipo == 'Aliado'" class="card-icon aliado" :style="{'background-image': `url(${require('@/assets/icon_aliado.png')})`, marginLeft: '5px'}"><span>{{card.fuerza}}</span></div>
            <div v-if="card.tipo == 'Arma'" class="card-icon" :style="{'background-image': `url(${require('@/assets/icon_arma.png')})`, marginLeft: '5px'}"></div>
            <div v-if="card.tipo == 'Talismán'" class="card-icon" :style="{'background-image': `url(${require('@/assets/icon_talisman.png')})`, marginLeft: '5px'}"></div>
            <div v-if="card.tipo == 'Tótem'" class="card-icon" :style="{'background-image': `url(${require('@/assets/icon_totem.png')})`, marginLeft: '5px'}"></div>
            <div style="display: flex; flex-direction: column; margin-left: 10px;">
                <div style="font-size: 14px"><b>{{card.nombre}}</b></div>
                <div v-if="card.tipo == 'Aliado'" class="card-race">{{card.raza}}</div>
            </div>
            <div style="flex: 1 1 auto"></div>
            <!--<div v-if="card.frecuencia != 'Sin Frecuencia' || (card.frecuencia == 'Sin Frecuencia' && card.habilidad != '')" class="card-icon" :style="{'background-image': `url('/images/${edition}_${card.frecuencia.toLowerCase()}.png')`}"></div>-->
        </div>
        <div v-if="card.habilidad && showHabilidad" class="card-effect" v-html="card.habilidad"></div>
    </div>
</div>

<div v-if="display == 'CARD'" style="width: 150px; height: 210px; background-color: whitesmoke; margin: 2px; border-radius: 5px; overflow: hidden">
<img v-if="image" :src="image" style="width: 100%; height: 100%">
</div>

</div>
</template>

<script>
export default {
    props: {
        card: {
            type: Object,
            default: null
        },
        display: {
            type: String,
            default: 'LIST'
        },
        selectable: {
            type: Boolean,
            default: true
        },
        showHabilidad: {
            type: Boolean,
            default: true
        },
        showImage: {
            type: Boolean,
            default: true
        },
        showPreview: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
    },
    computed: {

    },
    watch: {

    }

}
</script>

<style>
.card-list {
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
}
.card-list.selectable {
    cursor: pointer;
    transition: all 0.1s linear;
}
.card-list.selectable:hover {
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3);
    transform: scale(1.01);
}
.card-icon {
    background-image: url('/images/espada sagrada oro.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card-icon span {
    color: black;
    font-size: 20px;
    
}
.card-effect {
    padding: 10px;
    background-color:ghostwhite;
    font-size: 11px;
    border-radius: 5px;
    margin-top: 5px;
}
.card-race {
    font-size: 11px;
    color: #666;
}
.card-icon.oro span {
    color: #a56500;
}
.card-icon.aliado span {
    color: #831401;
    margin-top: 4px;
}
</style>
